import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import _ from 'lodash';
import { TableColumn } from '../tableSettings';

export class ReportSchHd extends TrackableEntity {
    id: number = 0;
    customerId: number = 0;
    customerName: string = "";
    recipientEmails: string = "";
    shipmentType: string = "";
    frequency: number = 0;
    sendTime: string = "";
    timeZone: string = "";
    startDate: string|null = null;
    endDate: string|null = null;
    reportColumns: string = ""; //db 저장
    reportName: string = "";
    u1Id: string = "";
    u1Date: string|null = null;
    u2Id: string = "";
    u2Date: string|null = null;

    isColumnChange: boolean = false;
    isPaused: boolean = false;
    remark: string = '';
    templateName: string = '';
    //nextRuntimeUTC: string|null = null; //백엔드에서만 사용

    //front
    oldStartDate: string|null = null;
    oldEndDate: string|null = null;
    oldSendTime: string = '';


    constructor(init?:Partial<ReportSchHd>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        const dicFieldMap:IDictionary<DBMappingInfo> = {};
        _.keys(ReportSchHd.dicFieldMappings).forEach(m=>{
            dicFieldMap[m] = ReportSchHd.dicFieldMappings[m];
        });

        return dicFieldMap;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_RPTSCHEDULE' }),
        'customerId': new DBMappingInfo({ field: 'F_Customer', table: 'T_RPTSCHEDULE' }),
        'customerName': new DBMappingInfo({ field: 'F_CustomerName', table: 'T_RPTSCHEDULE' }),
        'recipientEmails': new DBMappingInfo({ field: 'F_RecipientEmails', table: 'T_RPTSCHEDULE' }),
        'shipmentType': new DBMappingInfo({ field: 'F_Type', table: 'T_RPTSCHEDULE' }),
        'frequency': new DBMappingInfo({ field: 'F_Frequency', table: 'T_RPTSCHEDULE' }),
        'sendTime': new DBMappingInfo({ field: 'F_SendTime', table: 'T_RPTSCHEDULE' }),
        'timeZone': new DBMappingInfo({ field: 'F_TimeZone', table: 'T_RPTSCHEDULE' }),
        'startDate': new DBMappingInfo({ field: 'F_StartDate', table: 'T_RPTSCHEDULE' }),
        'endDate': new DBMappingInfo({ field: 'F_EndDate', table: 'T_RPTSCHEDULE' }),
        'reportColumns': new DBMappingInfo({ field: 'F_ReportColumns', table: 'T_RPTSCHEDULE' }),
        'reportName': new DBMappingInfo({ field: 'F_ReportName', table: 'T_RPTSCHEDULE' }),
        'u1Id': new DBMappingInfo({ field: 'F_U1ID', table: 'T_RPTSCHEDULE' }),
        'u1Date': new DBMappingInfo({ field: 'F_U1Date', table: 'T_RPTSCHEDULE' }),
        'u2Id': new DBMappingInfo({ field: 'F_U2ID', table: 'T_RPTSCHEDULE' }),
        'u2Date': new DBMappingInfo({ field: 'F_U2Date', table: 'T_RPTSCHEDULE' }),
        'isPaused': new DBMappingInfo({field:'F_IsPaused', table: 'T_RPTSCHEDULE'}),
        'remark': new DBMappingInfo({field:'F_Remark', table: 'T_RPTSCHEDULE'}),
        'templateName': new DBMappingInfo({field:'F_TemplateName', table: 'T_RPTSCHEDULE'}),

        //'nextRuntimeUTC': new DBMappingInfo({field: "F_NextRuntimeUTC", table: 'T_RPTSCHEDULE'}),
    };

}
